import React, { useContext } from 'react';
import COButton from '../COButton';
import styles from './DataMapDrawer.module.scss';
import { ReactComponent as Arrow } from 'assets/icons/arrow_fill.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow_drop_down_FILL0_wght400_GRAD0_opsz48 (1).svg';
import CreateProductStageNavigationBar from '../CreateProductStageNavigationBar';
import CarbonEmissionScale from '../CarbonEmissionScale';
import { useLocation } from 'react-router-dom';
import { EmissionDataContext } from 'context/EmissionDataContext';
import { DataMapDrawerPropsEnums } from 'enums/DataMapDrawerEnums';
import MappingDiagramCanvas from './MappingDiagramCanvas';
import { isActiveTab } from './DataMapDrawerHelper';
import { DataMappingProps } from 'enums/CreateProductStageNavigationBarEnums';
import clsx from 'clsx';
import { TabsKeys } from 'enums/ProductsViewEnums';
import { Product } from 'models/Product/product.model';
import { ProductMapRoots } from 'enums/ProductFlowMapEnums';

interface DataMapDrawer {
  handleToggleModal: () => void;
  toggleStatus: boolean;
  productId: number;
  stage: number | undefined;
  status: string | undefined;
  newProduct?: Product;
}

const DataMapDrawer: React.FC<DataMapDrawer> = ({
  handleToggleModal,
  productId,
  stage,
  toggleStatus,
  status,
  newProduct,
}: DataMapDrawer) => {
  const { stage1Data, stage2Data, stage3Data } =
    useContext(EmissionDataContext);
  const location = useLocation();

  // URLS
  const isRawMaterial = isActiveTab(DataMappingProps.RAW_MATERIAL, location);
  const stage1TotalLocal = localStorage.getItem('stage1EmissionTotal');
  const stage2TotalLocal = localStorage.getItem('stage2EmissionTotal');
  const stage3TotalLocal = localStorage.getItem('stage3EmissionTotal');
  const isDisabled =
    status === TabsKeys.IN_REVIEW
      ? true
      : newProduct?.status === TabsKeys.DRAFT ||
        newProduct?.status === TabsKeys.DECLINED ||
        newProduct?.status === TabsKeys.APPROVED
      ? false
      : null;

  const ArrowIcon = toggleStatus ? <ArrowDown /> : <Arrow />;

  const ToggleText = toggleStatus
    ? DataMapDrawerPropsEnums.CLICK_HERE_LESS
    : DataMapDrawerPropsEnums.CLICK_HERE;

  return (
    <div className={styles.drawer}>
      <div>
        {isDisabled || status === undefined ? (
          <div className={styles.stage1ExtraPadding}></div>
        ) : !isRawMaterial && !isDisabled ? (
          <COButton text onClick={handleToggleModal}>
            <p
              className={clsx({
                [styles.clickHereText]: toggleStatus === false,
                [styles.clickHereTextdown]: toggleStatus === true,
              })}>
              {ArrowIcon}
              {ToggleText}
            </p>
          </COButton>
        ) : (
          <div className={styles.stage1ExtraPadding}></div>
        )}
      </div>

      <div className={styles.overallContainer}>
        <div className={styles.contentContainer}>
          <CreateProductStageNavigationBar
            productId={productId}
            stage={stage}
            toggleStatus={toggleStatus}
            isDisabled={isDisabled}
            stage1Total={Number(stage1TotalLocal)}
            stage2Total={Number(stage2TotalLocal)}
            stage3Total={Number(stage3TotalLocal)}
          />
        </div>
        <div className={styles.carbonEmissionScaleContainer}>
          <CarbonEmissionScale />
        </div>
        <div
          className={styles.mapWrapper}
          id={ProductMapRoots.PRODUCT_CREATION_FLOW_ROOT}>
          <MappingDiagramCanvas
            stage1Data={stage1Data}
            stage2Data={stage2Data}
            stage3Data={stage3Data}
          />
        </div>
      </div>
    </div>
  );
};

export default DataMapDrawer;
